import Breadcrumb from "../components/Breadcrumb";
import CarListingStatusLayer from "../components/child/CarListingStatusLayer"

const CarListingApproved = () => {
  return (
    <>
        {/* Breadcrumb */}
        <Breadcrumb title='Approved Car Listing' />

        {/* <AnnouncementLayer /> */}
        <CarListingStatusLayer approvalStatusFilter="approved" />
    </>
  );
};

export default CarListingApproved;




